// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___LPW-","label":"styles_label__LdL0_"};